import { DestructureSupportDocs } from '../datasets/datasets.middleware';

const updateSolutionsSupportDocs = (data: SolutionsResultAction) => {
    const { response } = data;
    const { value } = response;
    let newResponse: ResponseUpdated[] = [];
    if (value && value.length > 0) {
        newResponse = (value as unknown as APISolutionUpdated[]).map((item: APISolutionUpdated) => {
            const { FormOrder = '', MarketPlaceSupportDocument = '', websiteurl = '', ...rest } = item as any;
            if (item.FormOrder && item.MarketPlaceSupportDocument && item.websiteurl) {
                return {
                    ...rest,
                    MarketSolutionSupportDocs: DestructureSupportDocs({
                        FormOrder: String(item.FormOrder || ''),
                        MarketPlaceSupportDocument: String(item.MarketPlaceSupportDocument || ''),
                        websiteurl: String(item.websiteurl || '')
                    })
                };
            }
            return { ...rest, MarketSolutionSupportDocs: [] };
        });
    }
    return { ...data, response: { ...response, value: newResponse } };
};

export default updateSolutionsSupportDocs;
